import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, autorun, observable, computed } from 'mobx';
import { Link } from 'react-router';
import Form, { FormBody, FormActions, SelectInput, TextInput } from '../../Form';
import DataTable from '../../DataTable';
import Spinner from '../../Spinner';
import { getDisplayDate, toUtc } from '../../../libs/date';

@inject('stationStore', 'rolePermissionStore', 'qcFlagStore')
@observer
class StationQcCheckList extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
  };

  @observable isLoading = true;
  @observable items;
  @observable itemsChanged = {};
  @observable dataSeriesFilterItems = [];
  @observable dataSeriesFilterItem = null;

  constructor(props) {
    super(props);

    this.state = {
      filteredItems: [],
    };
  }

  dispose;
  componentWillMount() {
    const { notify } = this.context;
    const { params: { id }, stationStore } = this.props;
    this.isLoading = true;
    stationStore.fetchQcChecks(id)
      .then(action(items => {
        this.isLoading = false;
        this.reset(items);
        this.setState({
          filteredItems: items,
        });
      }))
      .catch(action(err => {
        this.isLoading = false;
        notify.error(err);
      }));
  }

  @action reset(items) {
    const { params: { id }, qcFlagStore } = this.props;
    if (!items) { return; }
    this.items = items
      .map(item => {
        let flag = qcFlagStore.getProperFlag(item.quality);
        return Object.assign({}, item, {
          original_time: item.time,
          time: getDisplayDate(item.time),
          hqc: flag[0],
          qc2: flag[1],
          quality: flag[2],
          qc0: flag[3],
        })
      });
    this.dataSeriesFilterItems = items
      .map(item => {
        return item.data_series;
      })
      .filter((item, i, arr) => arr.indexOf(item) === i)
      .map(item => ({ label: item }))
      ;
  }

  @action onChangeHqc = (id, e) => {
    this.items = this.items
      .map(item => {
        if (item.id === id) {
          return Object.assign({}, item, {
            hqc: e.target.value,
          });
        }
        return item;
      });

    if (!this.itemsChanged[id]) {
      this.itemsChanged[id] = {};
    }
    this.itemsChanged[id].hqc = e.target.value;
  }

  @action onChangeDataSeriesFilter = (e) => {
    const dataSeriesFilter = e.target.value;
    this.dataSeriesFilterItem = dataSeriesFilter;

    let filteredItems;

    if (!this.dataSeriesFilterItem) {
      filteredItems = this.items;
    }

    filteredItems = this.items.filter(item => {
      return item.data_series === this.dataSeriesFilterItem;
    });

    this.setState({
      filteredItems,
    });

    // this.filteredItems = this.items.filter(item => {


    // });
  }

  getFilteredItems() {
    if (!this.dataSeriesFilterItem) {
      return this.items || [];
    }

    const filteredItems = this.items.filter(item => {
      return item.data_series === this.dataSeriesFilterItem;
    }) || [];
    return filteredItems;
    // return this.items.filter(item => {
    // return item.data_series === this.dataSeriesFilterItem;
    // });
  }
  @computed get filteredItems() {
    if (!this.dataSeriesFilterItem) {
      return this.items;
    }

    const filteredItems = this.items.filter(item => {
      return item.data_series === this.dataSeriesFilterItem;
    });
    return filteredItems;
    // return this.items.filter(item => {
    // return item.data_series === this.dataSeriesFilterItem;
    // });
  }

  @action onChangeValue = (id, e) => {
    this.items = this.items
      .map(item => {
        if (item.id === id) {
          return Object.assign({}, item, {
            value: e.target.value,
          });
        }
        return item;
      });

    if (!this.itemsChanged[id]) {
      this.itemsChanged[id] = {};
    }
    this.itemsChanged[id].value = e.target.value;
  }

  @action saveHqc = () => {
    const { notify } = this.context;
    const { params: { id }, stationStore } = this.props;

    let payload = this.items
      .filter(item => Object.keys(this.itemsChanged).map(id => +id).indexOf(+item.id) > -1)
      .map(item => ({
        series_id: +item.series_id, 
        time: item.original_time, 
        id: +item.id, 
        value: item.value, 
        hqc: item.hqc, 
        qc_flag: +`${item.hqc}${item.qc2}${item.quality}${item.qc0}`, 
        observation_id: item.observation_id
      }))

    this.isLoading = true;
    stationStore.saveQcChecks(id, payload)
      .then(action(() => {
        this.isLoading = false;
        // this.reset(items);
      }))
      .catch(action(err => {
        this.isLoading = false;
        notify.error(err);
      }));
  }

  render() {
    const { params: { id }, rolePermissionStore } = this.props;
    let modifyPermission = rolePermissionStore.validateRole('modify qc-check');
    // Parameter Name, Time, Value, QC Flag
    const columns = [
      // { key: 'id', label: 'ID', colClassName: 'level-2-align-right' },
      // { key: 'parameter_code', label: 'Parameter Name' },
      { key: 'data_series', label: 'Data Series' },
      { key: 'time', label: 'Time' },
      { key: 'value', label: 'Value', options: modifyPermission ? { type: 'number', onChange: this.onChangeValue } : null },
      { key: 'hqc', label: 'HQC', sortable: true, options: modifyPermission ? { type: 'number', onChange: this.onChangeHqc, min: 0, max: 9 } : null },
      { key: 'qc2', label: 'QC2', sortable: true },
      { key: 'quality', label: 'QC1', sortable: true },
      { key: 'qc0', label: 'QC0', sortable: true },
      { key: 'error_message', label: 'Error Message' },
      // { key: 'data_origin', label: 'Data Origin' },
    ];

    if (this.isLoading) { return <Spinner />; }

    return (
      <div>
        <Form>
          <SelectInput
            label={'Data Series'}
            fields={{ label: 'label', value: 'label' }}
            options={this.dataSeriesFilterItems}
            onChange={this.onChangeDataSeriesFilter}
            value={this.dataSeriesFilterItem}
          />
        </Form>
        {modifyPermission && <button className="small button right" onClick={this.saveHqc}>Save</button>}
        <DataTable
          data={this.filteredItems}
          sortRow={items => items.sort((a, b) => {
            if (a.data_series === b.data_series) return new Date(a.time).valueOf() > new Date(b.time).valueOf() ? -1 : 1;
            else a.data_series < b.data_series ? -1 : 1;
          })}
          slug={'qc-check'}
          columns={columns}
          resource='qc-check'
        />
      </div>
    );
  }
}

export default StationQcCheckList;



// WEBPACK FOOTER //
// ./src/components/Station/QcCheck/StationQcCheckList.js